import * as THREE from 'three';
import { RGBELoader } from 'three/examples/jsm/loaders/RGBELoader';

export function setEnvironment(scene, renderer) {
    const loader = new RGBELoader().setDataType( THREE.UnsignedByteType );
    const pmremGenerator = new THREE.PMREMGenerator( renderer );
    pmremGenerator.compileEquirectangularShader();
    
    //loader.load( '/textures/peppermint_powerplant_2_2k.hdr', ( texture ) => {
    loader.load( '/textures/SkyBox_With_Model-min.hdr', ( texture ) => {
        
        const envMap = pmremGenerator.fromEquirectangular( texture ).texture;
        pmremGenerator.dispose();

        scene.environment = envMap;
        scene.background = envMap
    //   debugObject.envMapIntensity = .1
    //   gui.add(debugObject, 'envMapIntensity').min(0).max(10).step(0.1).onChange(updateAllMaterials)

    }, undefined, (err)=>{
        console.error( 'An error occurred setting the environment');
    } );

    // const cubeTextureLoader = new THREE.CubeTextureLoader();

    // const environmentMap = cubeTextureLoader.load([
    //     '/textures/environmentMaps/0/pic.jpg', //nani diwal px ->  pz
    //     '/textures/environmentMaps/0/pic.jpg', // nano glass nx -> nz
    //     '/textures/environmentMaps/0/pic.jpg',
    //     '/textures/environmentMaps/0/pic.jpg',
    //     '/textures/environmentMaps/0/pic.jpg',  // moti diwal pz -> nx
    //     '/textures/environmentMaps/0/pic.jpg'   // moto glass nz -> px
    // ])

    // environmentMap.encoding = THREE.sRGBEncoding

    // scene.background = environmentMap
    // scene.environment = environmentMap

    //debugObject.envMapIntensity = 2.7
}
    